import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { DataFlowMessage, DqStatsMessage } from '@/lib/websocket';

interface JobMonitoringState {
    dataFlowMap: Record<string, DataFlowMessage>;
    dqStatsMap: Record<string, DqStatsMessage>;
}

const initialState: JobMonitoringState = {
    dataFlowMap: {},
    dqStatsMap: {},
};

const slice = createSlice({
    name: 'jobMonitoring',
    initialState,
    reducers: {
        dataFlowReceived(state, action: PayloadAction<DataFlowMessage>) {
            state.dataFlowMap[String(action.payload.id)] = action.payload;
        },
        dqStatsReceived(state, action: PayloadAction<DqStatsMessage>) {
            state.dqStatsMap[String(action.payload.id)] = action.payload;
        },
    },
});

export const { dataFlowReceived, dqStatsReceived } = slice.actions;
export default slice.reducer;